import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observe, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Prompt, withRouter } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { EButton, EInput } from 'src/Components/EInput';
import { TestsStore } from 'src/Stores/Tests/TestsStore';
import DeepCopy from 'src/UtilityFunctions/DeepCopy';
import { IDrillBit, ITest } from '../../../../../Interfaces/TestInterface';
import { IWell } from '../../../../../Interfaces/WellInterface';
import { CalcStore } from '../../../../../Stores/Calc/CalcStore';
import DataTable from '../../../../DataTable';
import Footer from '../../../../Footer';
import WorkflowHeader from '../../../WorkflowHeader/WorkflowHeader';

interface IList {
    headers: any[];
    rows: any[];
}

@inject('stores')
@observer
class BitData extends React.Component {
    public props: any;
    private dataSet: IList;
    private test: ITest = new ITest();
    public TestsStore: TestsStore;
    private testDisposer: any;
    private well: IWell = new IWell();
    public WellsStore: any;
    private wellDisposer: any;
    private drillBit: IDrillBit = new IDrillBit();
    private selectedBit: IDrillBit;
    public CalcStore: CalcStore;
    public pageValidatedForm: any;

    public state = {
        dataSet: this.dataSet,
        dataSetCurrent: this.dataSet,
        drillBit: this.drillBit,
        editing: false,
        isDirty: false,
        modal: false,
        newBitRequired: false,
        rowIndex: 0,
        saveClicked: false,
        selectedBit: this.selectedBit,
        test: this.test,
        well: this.well
    };

    constructor(props: any, context: any) {
        super(props, context);

        this.TestsStore = this.props.stores.TestsStore;
        this.WellsStore = this.props.stores.WellsStore;
        this.CalcStore = this.props.stores.CalcStore;
        
        this.state.drillBit = new IDrillBit();
        this.state.editing = false;
    }

    public componentDidMount() {
        if ( this.props.stores.WellsStore.well && this.props.stores.TestsStore.test ) {
            const test = this.TestsStore.test;
            this.TestsStore.calculateBitData(test);
            this.setState({
                selectedBit: this.TestsStore.test.bitData.bits && this.TestsStore.test.bitData.bits[0] ? toJS(this.TestsStore.test.bitData.bits[0]) : new IDrillBit(),
                test,
                well: toJS(this.WellsStore.well)
            }, () => {
                this.formatDataTable();
            });

        } else {
            if ( ! this.TestsStore.test ) {
                this.TestsStore.getTestDetails(this.props.match.params.taskId, this.props.match.params.wellId);
            }
            if ( ! this.WellsStore.well ) {
                this.WellsStore.getWellDetails(this.props.match.params.wellId);
            }
        }
        this.createDisposers();
    }

    public createDisposers() {
        this.testDisposer = observe(this.TestsStore, 'test', (change: any) => {
            const test = toJS(change.newValue);
            const selectedBit = test.bitData.bits[0] ? test.bitData.bits[0] : new IDrillBit();
            this.TestsStore.calculateBitData(test);
            this.setState({
                selectedBit,
                test
            }, () => {
                this.formatDataTable();

                if ( this.newBitRequired() ) {
                    this.toggleModal();
                }
            });
        });
        this.wellDisposer = observe(this.WellsStore, 'well', (change: any) => {
            const well = toJS(change.newValue);
            this.setState({
                well
            });
        });
    }

    private formatDataTable() {
        const newDataList: any[] = [];
        const newDataListCurrent: any[] = [];
        const tableHeaders = [
            'Bit Used',
            'Size',
            'Make',
            'Model',
            'Type',
            'Depth In (MD)',
            'Depth Out',
            'TFA (sq in)',
            'Re-Run'
        ];
        if ( this.state.test.bitData.bits ) {
            this.state.test.bitData.bits.map((bit: IDrillBit, index: number) => {
                const newObject = [
                    {
                        content: bit.bitNumber
                    },
                    {
                        content: Number(bit.bitSize).toFixed(3)
                    },
                    {
                        content: bit.make
                    },
                    {
                        content: bit.model
                    },
                    {
                        content: bit.bitType
                    },
                    {
                        content: bit.depthIn
                    },
                    {
                        content: bit.depthOut
                    },
                    {
                        content: bit.tfa
                    },
                    {
                        content: bit.reRun ? 'Yes' : 'No'
                    }
                ];
                newDataList.push(newObject);
                if(index === 0) {
                    newDataListCurrent.push(newObject);
                }
            });
        }
        const listStructure = {
            headers: tableHeaders,
            rows: newDataList
        };

        const listStructureCurrent = {
            headers: tableHeaders,
            rows: newDataListCurrent,
        };

        this.setState({
            dataSet: listStructure,
            dataSetCurrent: listStructureCurrent,
        });
    }

    public async componentWillUnmount() {
        this.clearDisposers();
    }

    public clearDisposers() {
        if ( this.testDisposer ) {
            this.testDisposer();
        }
        if ( this.wellDisposer ) {
            this.wellDisposer();
        }
    }

    private toggleModal = () => {
        if ( this.state.modal ) {
            const drillBit = new IDrillBit();
            drillBit.jetSizes = [''];
            this.setState({
                drillBit,
                editing: false,
                modal: !this.state.modal
            });
        } else {
            this.setState({
                modal: !this.state.modal
            });
        }
    }

    private handleCancel = () => {
        this.setState({
            drillBit: new IDrillBit(),
            editing: false
        });
        this.toggleModal();
    }

    private calcNozzleArea = ( jetSizes: number[]) => {
        const tfa = this.CalcStore.nozzleArea({jetSizes});
        return isFinite(tfa) ? Number(tfa.toFixed(2)) : 0;
    }
    private handleSave = (addAnother: boolean) => () => {
        const test = this.state.test;

        if (!Array.isArray(test.bitData.bits)) {
            test.bitData.bits = [];
        }
        if ( ! this.state.editing ) {
            const currBitNum = test.bitData.bits[0] ? test.bitData.bits[0].bitNumber : 0;
            this.state.drillBit.bitNumber = currBitNum + 1;

            const jetSizes: number[] = this.state.drillBit.jetSizes.filter((size: number) => {
                return (Number(size) !== 0);
            }).map(size => Number(size));
            this.state.drillBit.jetSizes = jetSizes.slice();
            const drillBitTfa = this.calcNozzleArea(jetSizes);
            this.state.drillBit.tfa = drillBitTfa ? Number(drillBitTfa.toFixed(2)) : 0;
            this.state.drillBit.createdWellTestId = test.id;
            if(test.bitData.bits[0]) {
                test.bitData.bits[0].depthOut = Number(this.state.drillBit.depthIn);
            }
            test.bitData.bits.unshift(DeepCopy(this.state.drillBit));
            test.bitData.estHoleSize = Number(this.state.drillBit.bitSize);
        } else {
            const editingJetSizes: number[] = this.state.drillBit.jetSizes.filter((size: number) => {
                return (Number(size) !== 0);
            }).map(size => Number(size)).slice();
            this.state.drillBit.jetSizes = editingJetSizes;
            this.state.drillBit.tfa = this.calcNozzleArea(editingJetSizes);
            this.state.test.bitData.bits[this.state.rowIndex] = DeepCopy(this.state.drillBit);
        }

        this.TestsStore.calculateBitData(test);
        const myNewBit = new IDrillBit();
        myNewBit.jetSizes = [''];
        this.setState({
            isDirty: true,
            test
        }, () => {
            this.setState({
                drillBit: myNewBit,
                editing: false,
                selectedBit: this.state.editing ? this.state.test.bitData.bits[this.state.rowIndex] :
                    ( this.state.test.bitData.bits[0] ? this.state.test.bitData.bits[0] : new IDrillBit())
            });
        });
        this.formatDataTable();
        if (!addAnother) {
            this.toggleModal();
        }
    }

    private handleSelect = (index: number) => {
        const selectedBit = this.state.test.bitData.bits[index];
        this.setState({
            selectedBit
        });
    }

    private handleEdit = (index: number) => {
        const drillBit = DeepCopy(this.state.test.bitData.bits[index]);
        this.setState({
            drillBit,
            editing: true,
            rowIndex: index,
        });
        this.toggleModal();
    }

    private handleDelete = (index: number) => {
        const test = this.state.test;
        const bits = test.bitData.bits;
        bits.splice(index, 1);
        test.bitData.bits = bits;
        this.setState({
            isDirty: true,
            selectedBit: this.state.test.bitData.bits[0] ? this.state.test.bitData.bits[0] : new IDrillBit(),
            test
        });
        this.formatDataTable();
    }

    private isDelibleList = (index?: number) => {
        if (this.state.test === undefined) {
            return [];
        }
        if (index === undefined) {
            return this.state.test.bitData.bits.map(value => value.createdWellTestId === this.state.test.id && this.state.test.testStatus !== 'Approved');
        } else if(this.state.test.bitData.bits[index] !== undefined) {
            return [this.state.test.bitData.bits[index].createdWellTestId === this.state.test.id && this.state.test.testStatus !== 'Approved'];
        } else {
            return [];
        }
    }
    private removeJet = (index: number) => (event:any) => {
        const drillBit = this.state.drillBit;
        drillBit.jetSizes.splice(index, 1);
        
        this.setState({
            drillBit
        });
    }

    private addJetSize = () => {
        const drillBit = this.state.drillBit;
        const tempBitJetSize = drillBit.jetSizes[drillBit.jetSizes.length - 1] 
            ? drillBit.jetSizes[drillBit.jetSizes.length - 1] 
            : 0;
        drillBit.jetSizes.push(tempBitJetSize);
        this.setState({
            drillBit
        });
    }

    private editJetSize = (event: any) => {
        const index = event.target.getAttribute('data-index');
        const drillBit = this.state.drillBit;
        drillBit.jetSizes[index] = event.target.value;
        this.setState({
            drillBit
        });
    }

    private handleInputChange = (event: any) => {
        const test = this.state.test;
        test.bitData[event.target.name] = event.target.value;
        this.TestsStore.calculateBitData(test);
        this.setState({
            isDirty: true,
            test
        });
    }

    private handleModalInputChange = (event: any) => {
        const drillBit = this.state.drillBit;
        drillBit[event.target.name] = event.target.value;
        this.setState({
            drillBit
        });
    }

    private handleRadioSelect = (event: any) => {
        const drillBit = this.state.drillBit;
        const reRun = event.target.value;
        drillBit[event.target.name] = ( reRun === 'true' );
        this.setState({
            drillBit
        });
    }

    private handleRadioSelectPipeClosed = (event: any) => {
        const test = this.state.test;
        const isPipeClosed = event.target.value;
        test.bitData[event.target.name] = (isPipeClosed === 'true');
        this.setState({
            isDirty: true,
            test
        });
    }

    private updateTestModel = () => {
        this.TestsStore.updateTestModel(this.state.test, this.props.match.params.wellId).then((test: any) => {
            if (test) {
                this.setState({
                    isDirty: false,
                });
            }
        });
    }

    private buttonNavigation = (event: any) => {
        const $target = event.target;
        if ( $target.name === 'previous' ) {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/test/' + this.props.match.params.taskId + '/welldata/managecontacts');
        } else {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/test/' + this.props.match.params.taskId + '/holegeometry/drillstring');
        }
    }

    private newBitRequired() {
        const bits: any[] = this.state.test.bitData.bits;
        const bitLength = bits.length;
        if ( bitLength > 0 ) {
            const lastBit: IDrillBit = bits[0];

            if ( lastBit.depthOut > 0 ) {
                return true;
            }
        }

        return false;
    }
    public render() {
        const currWell = this.WellsStore.well;
        const disableWellStatus = currWell !== undefined && currWell.wellStatus !== 'Active';
        return(
            <div className="BitData">
            <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
                <WorkflowHeader workflowHeaderItems={this.props.workflowHeaderItems} isInventoryReport={this.state.test.isInventoryReport}/>
                <div style={{marginBottom: '1rem'}}>
                    <h4 className="table-h4">
                        Current Bit
                        { this.newBitRequired() &&
                            <span style={{fontSize: '0.7em', color: 'red', marginLeft: '18px'}}>
                                Latest Depth Out has been set. You must add a new bit
                            </span>
                        }
                    </h4>
                    <DataTable
                        list={this.state.dataSetCurrent}
                        onNew={{
                            callback: this.toggleModal,
                            text: 'Add Bit'
                        }}
                        onSelect={this.handleSelect}
                        onEdit={this.handleEdit}
                        onDelete={this.handleDelete}
                        delibleList={this.isDelibleList(0)}
                        disableEditing={disableWellStatus}
                    />
                </div>
                <Form>
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label>RPM</Label>
                                <EInput
                                    type="text"
                                    id="rpm"
                                    name="rpm"
                                    data-validation="integer"
                                    value={this.state.test.bitData.rpm}
                                    onChange={this.handleInputChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>ROP(ft/hr)</Label>
                                <EInput
                                    type="text"
                                    id="rop"
                                    name="rop"
                                    data-validation="integer"
                                    value={this.state.test.bitData.rop}
                                    onChange={this.handleInputChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Weight On Bit (lbs)</Label>
                                <EInput
                                    type="text"
                                    id="wob"
                                    name="wob"
                                    data-validation="integer"
                                    value={this.state.test.bitData.wob}
                                    onChange={this.handleInputChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Torque Max (lbs)</Label>
                                <EInput
                                    type="text"
                                    id="torqueMax"
                                    name="torqueMax"
                                    data-validation="integer"
                                    value={this.state.test.bitData.torqueMax}
                                    onChange={this.handleInputChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Estimated Washout (in)</Label>
                                <EInput
                                    type="text"
                                    id="washout"
                                    name="washout"
                                    data-validation="decimal"
                                    value={this.state.test.bitData.washout}
                                    onChange={this.handleInputChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Estimated Hole Size (in)</Label>
                                <EInput
                                    type="text"
                                    id="estHoleSize"
                                    name="estHoleSize"
                                    value={this.state.test.bitData.estHoleSize}
                                    disabled={true}
                                    onChange={this.handleInputChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>TFA (sq/in)</Label>
                                <EInput
                                    type="text"
                                    disabled={true}
                                    id="tfa"
                                    name="tfa"
                                    value={
                                        this.state.test.bitData.bits ? (this.state.test.bitData.bits[0]
                                        ? this.state.test.bitData.bits[0].tfa
                                        : 0 ) : 0
                                    }
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>ECD (ppg)</Label>
                                <EInput
                                    type="text"
                                    disabled={true}
                                    id="ecd"
                                    name="ecd"
                                    value={this.state.test.bitData.ecd}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Nozzle Velocity (ft/sec)</Label>
                                <EInput
                                    type="text"
                                    disabled={true}
                                    id="nozzleVelocity"
                                    name="nozzleVelocity"
                                    value={this.state.test.bitData.nozzleVelocity}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Jet Impact Force (lbf)</Label>
                                <EInput
                                    type="text"
                                    disabled={true}
                                    id="jetImpactForce"
                                    name="jetImpactForce"
                                    value={this.state.test.bitData.jetImpactForce}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Bit Hydraulic Hrspwr (sq/in)</Label>
                                <EInput
                                    type="text"
                                    disabled={true}
                                    id="hydraulicHorsepower"
                                    name="hydraulicHorsepower"
                                    value={this.state.test.bitData.hydraulicHorsepower}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Bit Pressure Drop (psi)</Label>
                                <EInput
                                    type="text"
                                    disabled={true}
                                    id="pressureDrop"
                                    name="pressureDrop"
                                    value={this.state.test.bitData.pressureDrop}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>Percent Pressure Drop</Label>
                                <EInput
                                    type="text"
                                    disabled={true}
                                    id="percentPressureDrop"
                                    name="percentPressureDrop"
                                    value={this.state.test.bitData.percentPressureDrop}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Surge Pressure (ppg)</Label>
                                <EInput
                                    type="text"
                                    disabled={true}
                                    id="surgePressure"
                                    name="surgePressure"
                                    value={this.state.test.bitData.surgePressure}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Swab Pressure (ppg)</Label>
                                <EInput
                                    type="text"
                                    disabled={true}
                                    id="swabPressure"
                                    name="swabPressure"
                                    value={this.state.test.bitData.swabPressure}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>N Value</Label>
                                <EInput
                                    type="text"
                                    disabled={true}
                                    id="nValue"
                                    name="nValue"
                                    value={this.state.test.bitData.nValue}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>K Value</Label>
                                <EInput
                                    type="text"
                                    disabled={true}
                                    id="kValue"
                                    name="kValue"
                                    value={this.state.test.bitData.kValue}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Reynolds Number</Label>
                                <EInput
                                    type="text"
                                    disabled={true}
                                    id="reynoldsNumber"
                                    name="reynoldsNumber"
                                    value={this.state.test.bitData.reynoldsNumber}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: '2rem'}}>
                        <Col md="2">
                            <FormGroup>
                                    <Label>Trip Speed (ft/min)</Label>
                                    <EInput
                                        type="text"
                                        id="tripSpeed"
                                        name="tripSpeed"
                                        data-validation="decimal"
                                        value={this.state.test.bitData.tripSpeed}
                                        onChange={this.handleInputChange}
                                    />
                            </FormGroup>
                        </Col>
                        { (this.state.test.bitData.tripSpeed > 0) &&
                            <React.Fragment>
                                <Col md="5" style={{paddingTop: '1.75rem'}}>
                                    Trip Speed ft/min Required for Surge and Swab Pressure
                                </Col>
                                <Col md="3" style={{paddingTop: '1.75rem'}}>
                                    <FormGroup check={true} inline={true}>
                                        <Label check={true}>
                                            <Input
                                                name="isPipeClosed"
                                                id="isPipeClosed"
                                                type="radio"
                                                value="true"
                                                onChange={this.handleRadioSelectPipeClosed}
                                                checked={this.state.test.bitData.isPipeClosed}
                                            /> Closed
                                        </Label>
                                    </FormGroup>
                                    <FormGroup check={true} inline={true}>
                                        <Label check={true}>
                                            <Input
                                                name="isPipeClosed"
                                                id="isPipeClosed"
                                                type="radio"
                                                value="false"
                                                onChange={this.handleRadioSelectPipeClosed}
                                                checked={!this.state.test.bitData.isPipeClosed }
                                            /> Open
                                        </Label>
                                    </FormGroup>
                                </Col>
                            </React.Fragment>
                        }
                    </Row>
                    <Row>
                        <Col md="12">
                            <h4 className="table-h4">
                                Bit Information
                                { this.newBitRequired() &&
                                    <span style={{fontSize: '0.7em', color: 'red', marginLeft: '18px'}}>
                                        Latest Depth Out has been set. You must add a new bit
                                    </span>
                                }
                            </h4>
                            <DataTable
                                list={this.state.dataSet}
                                onSelect={this.handleSelect}
                                onEdit={this.handleEdit}
                                onDelete={this.handleDelete}
                                delibleList={this.isDelibleList()}
                                disableEditing={disableWellStatus}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12">
                            <h5>Jet Sizes for Bit Number: { this.state.selectedBit && this.state.selectedBit.bitNumber }</h5>
                        </Col>
                        { this.state.selectedBit && this.state.selectedBit.jetSizes &&
                            this.state.selectedBit.jetSizes.map((size: number, index: number) =>
                                <Col key={index} md="1" style={{'padding': '.375rem 0'}}>
                                    <EInput
                                        type="text"
                                        disabled={true}
                                        value={size}
                                    />
                                </Col>
                        ) }
                    </Row>
                    <Footer well={this.WellsStore.well} test={this.TestsStore.test} onSave={this.updateTestModel} onNavigate={this.buttonNavigation} />
                </Form>

                <Modal isOpen={this.state.modal} fade={false} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>
                        { this.state.editing ? 'Edit Bit' : 'Add New Bit' }
                    </ModalHeader>
                    <Form>
                        <ModalBody>
                            <Row>
                                <Col md="6">
                                    <FormGroup className="required">
                                        <Label>Size</Label>
                                        <EInput
                                            type="text"
                                            name="bitSize"
                                            id="bitSize"
                                            data-validation="decimal"
                                            required={true}
                                            value={this.state.drillBit.bitSize}
                                            onChange={this.handleModalInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup className="required">
                                        <Label>Make</Label>
                                        <EInput
                                            type="text"
                                            name="make"
                                            id="make"
                                            required={true}
                                            value={this.state.drillBit.make}
                                            onChange={this.handleModalInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <Label>Model</Label>
                                        <EInput
                                            type="text"
                                            name="model"
                                            id="model"
                                            value={this.state.drillBit.model}
                                            onChange={this.handleModalInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup className="required">
                                        <Label>Type</Label>
                                        <EInput
                                            type="text"
                                            name="bitType"
                                            id="bitType"
                                            required={true}
                                            value={this.state.drillBit.bitType}
                                            onChange={this.handleModalInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup className="required">
                                        <Label>Depth In (MD)</Label>
                                        <EInput
                                            type="text"
                                            name="depthIn"
                                            id="depthIn"
                                            data-validation="decimal"
                                            required={true}
                                            value={this.state.drillBit.depthIn}
                                            onChange={this.handleModalInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <Label>Depth Out</Label>
                                        <EInput
                                            type="text"
                                            name="depthOut"
                                            id="depthOut"
                                            data-validation="decimal"
                                            value={this.state.drillBit.depthOut}
                                            onChange={this.handleModalInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <Label>Re-Run</Label><br/>
                                    <FormGroup check={true} inline={true}>
                                        <Label check={true}>
                                            <EInput
                                                name="reRun"
                                                id="reRun"
                                                type="radio"
                                                value="true"
                                                onChange={this.handleRadioSelect}
                                                checked={this.state.drillBit.reRun}
                                            /> Yes
                                        </Label>
                                    </FormGroup>
                                    <FormGroup check={true} inline={true}>
                                        <Label check={true}>
                                            <EInput
                                                name="reRun"
                                                id="reRun"
                                                type="radio"
                                                value="false"
                                                onChange={this.handleRadioSelect}
                                                checked={!this.state.drillBit.reRun}
                                            /> No
                                        </Label>
                                    </FormGroup>
                                </Col>
                                <Col md="12">
                                    <hr/>
                                </Col>
                                <Col md="12">
                                    <FormGroup className="required">
                                        <Label>Jet Sizes</Label>
                                    </FormGroup>
                                    <FormGroup row={true}>
                                        { this.state.drillBit.jetSizes &&
                                                this.state.drillBit.jetSizes.map((size: number, index: number) =>
                                                <React.Fragment key={index}>
                                                    <Col xs="2" style={{'marginTop': 5, paddingLeft: 10, paddingRight: 2}}>
                                                        <EInput
                                                            type="text"
                                                            value={size}
                                                            data-validation="integer"
                                                            required={true}
                                                            data-index={index}
                                                            onChange={this.editJetSize}
                                                            />
                                                    </Col>
                                                    <Label xs="1" style={{'marginTop': 5, paddingLeft: 2, paddingRight: 2}} onClick={this.removeJet(index)}>
                                                        <FontAwesomeIcon icon={['far', 'trash-alt']}/>
                                                    </Label>
                                                </React.Fragment>
                                            ) }
                                    </FormGroup>
                                </Col>
                            </Row>
                        </ModalBody>
                        <ModalFooter>
                            <Button className="secondary" onClick={this.handleCancel}>Cancel</Button>
                            { this.displayAddJetSizeButton() &&
                                <Button color="primary" onClick={this.addJetSize}>Add Jet Size</Button>
                            }
                            <EButton color="primary" onClick={this.handleSave(false)}>Update</EButton>
                            {
                                !this.state.editing &&
                                <EButton color="primary" onClick={this.handleSave(true)}>Add Another</EButton>
                            }
                        </ModalFooter>
                    </Form>
                </Modal>
            </div>
        );
    }

    private displayAddJetSizeButton() {
        if ( this.state.editing ) {
            return this.addJetSizeButtonEdit();
        }
        return this.addJetSizeButtonAdd();
    }

    private addJetSizeButtonEdit() {
        const bits: any[] = this.state.test.bitData.bits;
        const jetSizes: any[] = bits[this.state.rowIndex].jetSizes;
        const length = jetSizes.length;
        const isEditing = this.state.editing;
        const hasJetSizes = (length > 0);
        const lastJetSizeNotZero = (hasJetSizes) ? Number(jetSizes[length - 1]) !== 0 : true;
        return (isEditing && lastJetSizeNotZero);
    }

    private addJetSizeButtonAdd() {
        const jetSizes = this.state.drillBit.jetSizes;
        const length = jetSizes.length;
        const isEditing = this.state.editing;
        const hasJetSizes = (length > 0);
        const lastJetSizeNotZero = (hasJetSizes) ? Number(jetSizes[length - 1]) !== 0 : true;
        return (!isEditing && (length === 0 || lastJetSizeNotZero));
    }
}

export default withRouter(BitData);



// WEBPACK FOOTER //
// ./src/Components/Main/TestWorkflow/HoleGeometry/BitData/BitData.tsx